import api from './api';

export const getAll = async (is_active = 1) => {
  try {
    const response = await api.get(`/users/getAll/${is_active}`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener los usuarios:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const getUserById = async id => {
  try {
    const response = await api.get(`/users/getUserById/${id}`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener el usuario:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const updateUser = async (id, data) => {
  try {
    const response = await api.put(`/users/update/${id}`, data);
    return response.data;
  } catch (error) {
    console.error(
      'Error al actualizar el usuario:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const createUser = async data => {
  try {
    const response = await api.post(`/users/add/`, data);
    return response.data;
  } catch (error) {
    console.error(
      'Error al actualizar el usuario:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};
